import { createReducer } from 'typesafe-actions'
import { Reducer } from 'redux'
import {
  ServiceAreasAction,
  ServiceAreasTypes,
  ServiceAreasState
} from '../types'

export const initState: ServiceAreasState = {
  isFetching: false,
  data: {
    content: []
  },
  error: ''
}

export const serviceAreasReducer: Reducer<ServiceAreasState> = createReducer<
  ServiceAreasState,
  ServiceAreasAction
>(initState, {
  [ServiceAreasTypes.FETCH_SERVICES_AREAS_REQUEST]: (
    state: ServiceAreasState
  ) => ({
    ...state,
    isFetching: true,
    data: {
      content: []
    }
  }),
  [ServiceAreasTypes.FETCH_SERVICES_AREAS_SUCCESS]: (
    state: ServiceAreasState,
    action
  ) => ({
    ...state,
    isFetching: false,
    data: {
      content: action.payload.data.content
    }
  }),
  [ServiceAreasTypes.FETCH_SERVICES_AREAS_FAIL]: (
    state: ServiceAreasState
  ) => ({
    ...state,
    isFetching: false
  })
})

export default serviceAreasReducer
